const defaultState = {
  myfilter: {},
  defaultFilter: {},
  savedFilters: {},
  filterName: "",
  isRetailer: "No",
  department: [],
  miscType: [],
  silos: [],
  price: [],
  classification: [],
  brands: [],
  year: [],
  category: [],
  subCategory: [],
  isRetailerDef: "No",
  departmentDef: [],
  typeDef: [],
  silosDef: [],
  priceDef: [],
  classificationDef: [],
  brandsDef: [],
  yearDef: [],
  categoryDef: [],
  subCategoryDef: [],
};
export default function filterReducer(state = defaultState, action = {}) {
  // console.log("inside action");
  // console.log(state);
  // console.log(action.type);
  switch (action.type) {
    case "UPDATE_FILTER":
      return {
        ...state,
        myfilter: action.filter,
      };
    case "SET_FILTER":
      return {
        ...state,
        myfilter: action.filter,
        defaultFilter: action.filter,
      };
    case "SET_SAVED_FILTER":
      return {
        ...state,
        savedFilters: {
          ...state.savedFilters,
          [action.payload.filterName]: action.payload.filter,
        },
      };
    case "SET_FILTERNAME":
      return {
        ...state,
        filterName: action.filterName,
      };
    case "SET_ISRETAILER":
      return {
        ...state,
        isRetailer: action.isRetailer,
      };
    case "SET_TOP_FILTER":
      return {
        ...state,
        isRetailer: action.filter.isRetailer,
        silos: action.filter.silos,
        department: action.filter.department,
        miscType: action.filter.miscType,
        price: action.filter.price,
        classification: action.filter.classification,
        brands: action.filter.brands,
        year: action.filter.year,
        category: action.filter.category,
        subCategory: action.filter.subCategory,
      };
    case "SET_DEFAULT_FILTER":
      return {
        ...state,
        isRetailerDef: action.filter.isRetailer,
        silosDef: action.filter.silos,
        departmentDef: action.filter.department,
        typeDef: action.filter.miscType,
        priceDef: action.filter.price,
        classificationDef: action.filter.classification,
        brandsDef: action.filter.brands,
        yearDef: action.filter.year,
        categoryDef: action.filter.category,
        subCategoryDef: action.filter.subCategory,
      };
    case "SET_DEPARTMENT":
      return {
        ...state,
        department: action.department,
      };
    case "SET_TYPE":
      return {
        ...state,
        miscType: action.miscType,
      };
    case "SET_SILOS":
      return {
        ...state,
        isRetailer: action.silos,
      };
    default:
      return state;
  }
}
